var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "../../../element-factory";
import { ReactSurveyElement } from "../../../reactquestion_element";
import { SvgIcon } from "../../svg-icon/svg-icon";
var SurveyQuestionMatrixDetailButton = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixDetailButton, _super);
    function SurveyQuestionMatrixDetailButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnShowHideClick = _this.handleOnShowHideClick.bind(_this);
        return _this;
    }
    SurveyQuestionMatrixDetailButton.prototype.getStateElement = function () {
        return this.props.item;
    };
    Object.defineProperty(SurveyQuestionMatrixDetailButton.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionMatrixDetailButton.prototype, "question", {
        get: function () {
            return this.props.item.data.question;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionMatrixDetailButton.prototype, "row", {
        get: function () {
            return this.props.item.data.row;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrixDetailButton.prototype.handleOnShowHideClick = function (event) {
        this.row.showHideDetailPanelClick();
    };
    SurveyQuestionMatrixDetailButton.prototype.renderElement = function () {
        var isExpanded = this.row.isDetailPanelShowing;
        var ariaExpanded = isExpanded;
        var ariaControls = isExpanded ? this.row.detailPanelId : undefined;
        return (React.createElement("button", { type: "button", title: this.props.item.title, onClick: this.handleOnShowHideClick, className: this.question.getDetailPanelButtonCss(this.row), "aria-expanded": ariaExpanded, "aria-controls": ariaControls },
            React.createElement(SvgIcon, { className: this.question.getDetailPanelIconCss(this.row), iconName: this.question.getDetailPanelIconId(this.row), size: "auto" })));
    };
    return SurveyQuestionMatrixDetailButton;
}(ReactSurveyElement));
export { SurveyQuestionMatrixDetailButton };
ReactElementFactory.Instance.registerElement("sv-matrix-detail-button", function (props) {
    return React.createElement(SurveyQuestionMatrixDetailButton, props);
});
